import {
  ApplicationRef,
  ComponentRef,
  Directive,
  ElementRef,
  HostListener,
  inject,
  Input, OnDestroy, ViewContainerRef
} from '@angular/core';
import {TooltipComponent} from "./tooltip.component";

export type AppTooltipPosition = 'above' | 'below' | 'before' | 'after';

@Directive({
  selector: '[appTooltip]',
  standalone: true,
  host: {
    ngSkipHydration: 'true'
  }
})
export class TooltipDirective implements OnDestroy {
  private appRef = inject(ApplicationRef);
  private elementRef = inject(ElementRef);
  private componentRef: ComponentRef<TooltipComponent> | null = null;
  private viewContainerRef = inject(ViewContainerRef);

  @Input() tooltip = '';

  @Input() tooltipDisabled = false;

  @Input() position: AppTooltipPosition = 'below';

  @HostListener('mouseenter')
  onMouseEnter(): void {
    if (this.componentRef === null && !this.tooltipDisabled) {
      this.componentRef = this.viewContainerRef.createComponent(TooltipComponent);
      this.setTooltipComponentProperties();
    }
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.destroy();
  }

  ngOnDestroy(): void {
    this.destroy();
  }

  destroy(): void {
    if (this.componentRef !== null) {
      this.appRef.detachView(this.componentRef.hostView);
      this.componentRef.destroy();
      this.componentRef = null;
    }
  }

  private setTooltipComponentProperties() {
    if (this.componentRef !== null) {
      this.componentRef.instance.tooltip = this.tooltip;
      this.componentRef.instance.position = this.position;
      this.componentRef.instance.disabled = this.tooltipDisabled;
      const {left, right, bottom, top} =
        this.elementRef.nativeElement.getBoundingClientRect();
      switch (this.position) {
        case "before":
          this.componentRef.instance.left = right;
          this.componentRef.instance.top = (bottom - top) / 2 + top - 12;
          this.componentRef.instance.bottom = undefined;
          this.componentRef.instance.right = undefined;
          break;
        case "after":
          this.componentRef.instance.left = right;
          this.componentRef.instance.top = (bottom - top) / 2 + top - 12;
          this.componentRef.instance.bottom = undefined;
          this.componentRef.instance.right = undefined;
          break;
        case "above":
          this.componentRef.instance.left = (right - left) / 2 + left;
          this.componentRef.instance.top = bottom - 2 * (bottom - top);
          this.componentRef.instance.bottom = undefined;
          this.componentRef.instance.right = undefined;
          break;
        default: // below
          this.componentRef.instance.left = (right - left) / 2 + left;
          this.componentRef.instance.top = bottom;
          this.componentRef.instance.bottom = undefined;
          this.componentRef.instance.right = undefined;
          break;
      }
    }
  }

}
